import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { PageID, RoomSb } from "~/extensions/utils/DefineTypes";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { isCurrentlyMovingIn, isMoveIn } from "../Models/RoomSelectHelper";
const log = Log.create("TaikyoFlowGuide");
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "TaikyoFlowGuidePage",
    beforeRouteEnter(to, from, next) {
        if (myPageStore.isMultipleKeiyaku) {
            const fromScreen = from.name;
            const relatedScreens = ["taikyo-room-list", "taikyo-precaution"];
            if (relatedScreens.includes(fromScreen)) {
                next();
                return;
            }
            next({ name: "taikyo" });
            return;
        }
        next();
    },
    setup() {
        const pageName = commonStore.pageName(PageID.taikyoFlowGuide);
        const isParking = myPageStore.selectedNyukyokeiyaku?.roomSb === RoomSb.Parking;
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const router = useRouter();
        const html = ref("");
        const flowItems = ref([]);
        const initView = async () => {
            try {
                if (taikyoStore.selectRoomSb === null) {
                    taikyoStore.roomSbCheck(myPageStore.selectedNyukyokeiyaku.roomSb);
                }
                let result = await api.taikyo.loadFlowGuideText();
                html.value = result;
                flowItems.value = await api.taikyo.getFlowGuideItems();
            }
            catch (ex) {
                log.error("setup", ex);
                MsgBox.error(ex.message);
            }
        };
        const onClick = async () => {
            if (!isMoveIn(myPageStore.selectedNyukyokeiyaku.jokyoKb) && isCurrentlyMovingIn(taikyoStore.taikyoEntity.status)) {
                await MsgBox.error(commonStore.messages.PE0001);
                router.push({ name: "top" });
                return;
            }
            router.push({ name: "taikyo-flow-next" });
        };
        initView();
        return {
            PageID,
            pageName,
            isMultipleKeiyaku,
            isParking,
            html,
            flowItems,
            onClick
        };
    }
});
